import { render, staticRenderFns } from "./SpD.vue?vue&type=template&id=f238edf6"
import script from "./SpD.vue?vue&type=script&lang=js"
export * from "./SpD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports